import React, {useState, useEffect} from 'react';
import Pagination from 'react-js-pagination';
import {useSelector} from 'react-redux';
import {NavLink, useHistory, useLocation} from 'react-router-dom';
import Table from 'react-bootstrap/Table';
import {toast} from 'react-toastify';
import {useMutation, useQuery} from 'react-query';
import {Image} from 'react-bootstrap';
import {AsyncPaginate} from 'react-select-async-paginate';
import {
    EXERCISE_API,
    BaseGatewayImage,
    DISEASE_API
} from '@app/utils/apiUrl.js';
import {DeleteSingle, Get} from '@app/utils/httpProvider';
import {
    createUrlWithParam,
    formatDateTimeCrawler,
    formatDateTimeMoment,
    formatDateTimeWithoutHour,
    formatDateTimeWithoutHourMoment,
    getInfomationAccountFromToken,
    isValidUrl
} from '../../utils/helper';
import {URI_INTERNAL} from '../../utils/pathLocations';
import {
    objectShowNumber,
    messageToast,
    objectDeviceStatus,
    deviceStatus,
    styleSelectDefault,
    role,
    objectTrangThaiDeNghi,
    trangThaiDeNghiValue,
    sortByValue
} from '../../utils/define';
import {ConfirmModal} from '../../modules/modal/ConfirmModal';
import {BrowserView, MobileView} from 'react-device-detect';
import Select from 'react-select';
import {Button} from '@components';

const SelectExercise = () => {
    const history = useHistory();
    const location = useLocation();
    const valueSearch = useSelector((state) => state.search.valueSearch);

    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(10000);
    const [search, setSearch] = useState('');

    const [openConfirmDeleteModal, setOpenConfirmDeleteModal] = useState(false);
    const [idWantDelete, setIdWantDelete] = useState('');
    const [confirmDelMessage, setConfirmDelMessage] = useState('');
    const [diseaseId, setDiseaseId] = useState('');
    const [diseaseName, setDiseaseName] = useState('');

    // let accountRoleAdmin = false;
    const inforAccount = getInfomationAccountFromToken();

    // if (inforAccount && inforAccount.role) {
    //     const userRole = inforAccount.role.split(', ');
    //     accountRoleAdmin =
    //         userRole.includes(role.Admin) || userRole.includes(role.Doctor);
    // }

    const deleteFunc = useMutation((value) =>
        DeleteSingle(EXERCISE_API.DELETE_ITEM, value, null)
    );

    const paramUrl = new URLSearchParams(location.search.substring(1));
    if (
        paramUrl.get('page') != null &&
        parseInt(paramUrl.get('page'), 10) !== page
    ) {
        const pageResult = parseInt(paramUrl.get('page'), 10);
        setPage(pageResult);
    }
    if (
        paramUrl.get('size') != null &&
        parseInt(paramUrl.get('size'), 10) !== pageSize
    ) {
        const sizeResult = parseInt(paramUrl.get('size'), 10);
        setPageSize(sizeResult);
    }
    if (paramUrl.get('search') != null && paramUrl.get('search') !== search) {
        setSearch(paramUrl.get('search'));
    }

    // const [isSortedNameAlphabet, setIsSortedNameAlphabet] = useState(false);

    const {isLoading, isError, error, data, refetch} = useQuery(
        ['selectExerciseData', valueSearch, page, pageSize],
        () => {
            if (diseaseId) {
                let model = {
                    Keyword: valueSearch ? valueSearch : '',
                    PageIndex: page,
                    PageSize: pageSize,
                    DiseaseId:
                        diseaseId && diseaseId.target && diseaseId.target.value
                            ? diseaseId.target.value.value
                            : ''
                };

                return Get(EXERCISE_API.GET_PAGING, null, model);
            }
        }
    );

    useEffect(() => {
        refetch();
    }, [pageSize, page, diseaseId]);

    const replaceHistory = async (Page, Size, Search) => {
        history.replace(
            createUrlWithParam(URI_INTERNAL.EXERCISE_PATH, {
                page: Page,
                size: Size,
                search: Search
            })
        );
    };

    React.useEffect(() => {
        if (valueSearch != null && valueSearch !== search) {
            replaceHistory(1, pageSize, valueSearch);
        }
    }, [valueSearch]);

    const changePage = (number) => {
        setPage(number);
        replaceHistory(number, pageSize, search);
    };

    const onChangeShowNumber = (e) => {
        setPageSize(e.target.value);
        replaceHistory(page, e.target.value, search);
    };

    // const deleteAction = (id, name) => {
    //     setIdWantDelete(id);
    //     setConfirmDelMessage(name);
    //     setOpenConfirmDeleteModal(true);
    // };

    // const acceptDelete = async () => {
    //     if (idWantDelete !== '') {
    //         deleteFunc.mutate(idWantDelete, {
    //             onSuccess: (res) => {
    //                 if (res.status === 201 || res.status === 200) {
    //                     refetch();
    //                     toast.success(messageToast.messageToastDeleteSuccess);
    //                     if (
    //                         data != null &&
    //                         data.data.length === 1 &&
    //                         page !== 1
    //                     ) {
    //                         history.push(
    //                             createUrlWithParam(URI_INTERNAL.EXERCISE_PATH, {
    //                                 page: page - 1,
    //                                 size: pageSize,
    //                                 search: search
    //                             })
    //                         );
    //                     }
    //                 } else {
    //                     toast.error(messageToast.messageToastDeleteError);
    //                 }
    //             },
    //             onError: (res) => {
    //                 toast.error(messageToast.messageToastTryCatch);
    //             }
    //         });

    //         replaceHistory(page, pageSize, search);
    //         setOpenConfirmDeleteModal(false);
    //     }
    // };

    // const cancelDelete = () => {
    //     setIdWantDelete('');
    //     setOpenConfirmDeleteModal(false);
    // };

    const loadOptions = async (search, loadedOptions, {page}) => {
        const pageSize = 10;
        const res = await Get(DISEASE_API.GET_PAGING, null, {
            PageIndex: page,
            PageSize: pageSize,
            AccountPatientId: inforAccount.id,
            Keyword: search // pass the input text to filter server-side
        });

        const data = res.data || [];
        const options = data.map((x) => ({
            label: `${x.name}`,
            value: x.id
        }));

        // assume your API returns total count or a flag for more pages
        const hasMore = data.length === pageSize;
        return {
            options,
            hasMore,
            additional: {page: page + 1}
        };
    };

    return (
        <div className="container-fluid">
            <div id="disease-tab-content" className="tab-content active">
                <div className="row">
                    <div className="col-md-12">
                        <div className="card card-primary card-outline">
                            <div className="card-header">
                                <h3 className="card-title">
                                    Chọn mặt bệnh
                                </h3>
                            </div>
                            <div className="card-body">
                                <div className="form-group">
                                    <AsyncPaginate
                                        name="diseaseId"
                                        id="diseaseId"
                                        placeholder="Chọn mặt bệnh"
                                        value={diseaseId.value}
                                        loadOptions={loadOptions}
                                        styles={styleSelectDefault}
                                        isClearable
                                        onChange={(selectedOption) => {
                                            const event = {
                                                target: {
                                                    name: 'diseaseId',
                                                    value: selectedOption
                                                }
                                            };
                                            setDiseaseId(event);
                                            setDiseaseName(
                                                selectedOption.label
                                            );
                                        }}
                                        additional={{
                                            page: 1
                                        }}
                                    />
                                </div>
                                {diseaseName ? (
                                    <div
                                        id="disease-description"
                                        className="alert alert-info"
                                        style={{display: 'block'}}
                                    >
                                        Các bài tập khôi phục cho {diseaseName}
                                    </div>
                                ) : (
                                    <></>
                                )}
                            </div>
                        </div>
                        <div id="exercises-list">
                            <div className="row">
                                {data != null &&
                                data.data != null &&
                                data.data != null &&
                                data.data !== undefined &&
                                data.data.length > 0 ? (
                                    <>
                                        {data.data.map((item, index) => (
                                            <div className="col-md-6">
                                                <div className="card exercise-item">
                                                    <div className="card-header">
                                                        <h3 className="card-title"></h3>
                                                    </div>
                                                    <div className="card-body">
                                                        <p>{item.name}</p>
                                                        {/* <p>
                                                            <i className="fas fa-redo text-info" />{' '}
                                                            Số lần tập mỗi buổi:{' '}
                                                            {
                                                                item.practiceCountMinimum
                                                            }{' '}
                                                            -{' '}
                                                            {
                                                                item.practiceCountMaximum
                                                            }
                                                        </p> */}
                                                        <Button
                                                            as={NavLink}
                                                            to={createUrlWithParam(
                                                                URI_INTERNAL.SELECTDOCTOR_PATH,
                                                                {baitapId: item.id}
                                                            )}
                                                            className="btn btn-primary select-exercise"
                                                            activeClassName="active" // adds .active when route matches
                                                        >
                                                            <i className="fas fa-check-circle" />{' '}
                                                            Chọn bài tập
                                                        </Button>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </>
                                ) : (
                                    <></>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SelectExercise;
